<ion-list id="checkbox-options" class="list-custom" role="list" *ngIf="itens" list-custom>
  <ion-item class="list-custom__row" [ngClass]="{'one-item': itens.length === 1}"  *ngFor="let item of itens">
    <label class="list-custom__label" tabindex="0" role="checkbox"
    [attr.aria-label]="item.ariaLabel" 
    [attr.aria-checked]="item.checked">
      <span aria-hidden="true" class="list-custom__text list-custom--item">{{item.value}}</span>
      <input type="checkbox" name="checkbox" [checked]="item.checked" [attr.value]="item.key" 
      class="list-custom__checkbox list-custom--item" (change)="item.checked = $event.target.checked; changeValue()" aria-hidden="true">
      <svg class="checkbox-icon list-custom__checkbox-custom" viewBox="0 0 24 24" part="container" aria-hidden="true">
        <path d="M1.73,12.91 8.1,19.28 22.79,4.59" part="mark"></path>
      </svg>
    </label>
  </ion-item>
</ion-list>